

















import mixins from 'vue-typed-mixins'
import { mapMutations, mapGetters } from 'vuex'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import SwitchTabs, { Tab } from '@/components/SwitchTabs/SwitchTabs.vue'
import { UserMutationTypes } from '@/store/modules/users/mutations'
import { UserFilter, UserStatus, UserScope } from '@/models/users'

interface Methods {
  getIcon: (status: UserStatus) => string
  handleSetFilter: (status: UserStatus) => void
}

interface Computed {
  filters: UserFilter[]
  canDoScope: (scope: UserScope) => boolean
  activeFilter: UserStatus
  filterTabs: Tab<UserStatus>[]
}

export default mixins(WindowResizeListener).extend<{}, Methods, Computed, {}>({
  components: {
    SwitchTabs,
  },
  computed: {
    ...mapGetters({
      filters: 'getFilters',
      canDoScope: 'canDoScope',
    }),
    activeFilter(): UserStatus {
      return this.$store.state.users.filter
    },
    filterTabs(): Tab<UserStatus>[] {
      return this.filters
        .filter(f => f.scope.every(s => this.canDoScope(s)))
        .map(f => {
          return {
            label: this.isMobile ? `(${f.count})` : `${f.label} (${f.count})`,
            value: f.status,
            icon: this.isMobile ? this.getIcon(f.status) : undefined,
          }
        })
    },
  },
  methods: {
    ...mapMutations({
      handleSetFilter: UserMutationTypes.Filter,
    }),
    getIcon(status: UserStatus) {
      switch (status) {
        case UserStatus.Invitation:
          return 'zmdi-hourglass-outline'
        case UserStatus.Inactive:
          return 'zmdi-delete'
        case UserStatus.Active:
          return 'zmdi-check-all'
        default:
          return 'zmdi-accounts'
      }
    },
  },
  mounted() {
    if (this.filterTabs.every(filter => filter.value !== this.activeFilter)) {
      return this.handleSetFilter(this.filterTabs[0].value)
    }
  },
})
